import React, { useState } from "react";
import {
  Typography,
  Box,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  Button,
  CircularProgress,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const DeleteDialog = (props: any) => {
  const { deletepopupShow, deletepopupClose, type, handleDeleteConfirm } =
    props;
  const [open, setOpen] = useState(false);
  const [isLoading, setIsloading] = React.useState(false);
  const [deleteEnable, setDeleteEnable] = useState(false);
  const [deleteTxt, setDeleteTxt] = useState("");
  const [isBtnLoading, setIsBtnLoading] = useState(false);

  const setDeleteHandle = (e: any) => {
    setDeleteTxt(e.target.value);
    setDeleteEnable(false);

    if (e.target.value.toLowerCase() == "delete") {
      setDeleteEnable(true);
    }
  };

  const clearInput = () => {
    setDeleteTxt("");
    setDeleteEnable(false);
  };
  const confirmDelete = (event: any) => {
    event.currentTarget.disabled = true;
    setIsBtnLoading(true);

    handleDeleteConfirm();
  };

  return (
    <Dialog
      className="delete-popup text-center"
      onClose={deletepopupClose}
      open={deletepopupShow}
      maxWidth="sm"
    >
      <Box
        sx={{ width: "100%" }}
        className={isLoading ? "delete-form-wrap loader" : "delete-form-wrap"}
      >
        <i className="icon-delete-1 popup-icon" />
        <DialogTitle>Delete Warning!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography className="info">
              <span>
                This operation will delete the {type} permanently and cannot be
                undone.
              </span>
            </Typography>
            <Typography className="confirm-txt">
              Type “delete” to confirm
            </Typography>
            <Box className="delete-form">
              <FormControl className="custom-select" fullWidth>
                <OutlinedInput
                  type="text"
                  value={deleteTxt}
                  onChange={setDeleteHandle}
                  label=""
                  endAdornment={
                    <InputAdornment position="end">
                      {deleteTxt.length > 0 && (
                        <IconButton
                          aria-label="search icon"
                          edge="end"
                          onClick={clearInput}
                        >
                          <CloseIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Button
                variant="contained"
                disabled={!deleteEnable}
                onClick={confirmDelete}
              >
                {isBtnLoading ? (
                  <CircularProgress
                    color="inherit"
                    size="1.2rem"
                    sx={{ marginRight: "2px" }}
                  />
                ) : (
                  ""
                )}
                delete
              </Button>
              <Button variant="text" onClick={deletepopupClose}>
                cancel
              </Button>
            </Box>
          </DialogContentText>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default DeleteDialog;
